import { auth } from './firebase';
import { accountGrowthApiConfig } from '@config/app.config';

// Bridges the admin Follower Growth chart to the account-growth Cloud Function
// (functions/lib/content_loop/accountGrowthReport.js). The join across
// dlh_accountSnapshots + dlh_posts + dlh_snapshots runs server-side behind an
// admin-gated endpoint — same auth pattern as analyticsReport.js.

async function authedFetch(url, options = {}) {
  const user = auth.currentUser;
  if (!user) throw new Error('You must be signed in as an admin to view growth.');
  const idToken = await user.getIdToken();

  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
      ...(options.headers || {}),
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.details || data.error || `Request failed with status ${res.status}`);
  }
  return data;
}

/**
 * Fetch the follower-growth bundle: { personas, series: {persona: [...daily]},
 * posts: [...] }. `series[persona]` is oldest-first daily snapshots with a
 * precomputed `followersDelta`; `posts` are X posts with date + engagement.
 */
export async function fetchAccountGrowth() {
  const data = await authedFetch(accountGrowthApiConfig.reportUrl);
  return data.report;
}
